module.exports = __webpack_public_path__ + "static/media/img-0bcb6888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/urgentteam-logo.png
// module id = 5305
// module chunks = 39